import React from "react";
import PayrollRomms from "../PayrollRomms";

interface BAPBRommsProps {
  onBack?: () => void;
}

export default function BAPBRomms({ onBack }: BAPBRommsProps) {
  return (
    <PayrollRomms
      onBack={onBack || (() => {})}
      onComplete={() => {}}
      workspace="Biological Assets other than Bearer Plants"
    />
  );
}
